import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constant } from 'app/config/constants';
import { DeviceCalendar } from 'app/model/entity/device-calendar';
import { SimpleDeliveryStatus } from 'app/model/entity/simple/simple-delivery-status';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 * Service class for simple delivery status action
 */
export class SimpleDeliveryStatusService {
  /**
   * URL for common simple playlist
   */
  simpleDeliveryStatusUrl = Constant.BACKEND_URL + Constant.DSC_SERVICE_URL + 'api/simple-delivery-status';
  /**
   * URL of device publish info API
   */
  deliveryStatusTimetableUrl = Constant.BACKEND_URL + Constant.COMMON_SERVICE_URL + 'api/delivery-status-timetable';

  constructor(private http: HttpClient) {}

  /**
   * Be used SIMPLE-SIGNAGE-EDITOR
   * get delivery status for devices
   * @returns
   */
  getDeliveryStatusForDevices(): Observable<Array<SimpleDeliveryStatus>> {
    return this.http.get<Array<SimpleDeliveryStatus>>(`${this.simpleDeliveryStatusUrl}/get-delivery-status-for-devices`);
  }

  /**
   * Be used SIMPLE-SIGNAGE-EDITOR
   * update status first time for devices
   *
   * @param deviceIds
   */
  updateStatusFirstTimeForDevices(deviceIds: Array<Number>): Observable<Array<SimpleDeliveryStatus>> {
    return this.http.post<Array<SimpleDeliveryStatus>>(`${this.simpleDeliveryStatusUrl}/first-time/update-status-for-devices`, deviceIds);
  }

  /**
   * Be used SIMPLE-SIGNAGE-EDITOR
   * update status first time for devices
   *
   * @param deviceIds
   */
  updateStatusForDevices(deviceIds: Array<Number>): Observable<Array<SimpleDeliveryStatus>> {
    return this.http.post<Array<SimpleDeliveryStatus>>(`${this.simpleDeliveryStatusUrl}/update-status-for-devices`, deviceIds);
  }

  /**
   * Be used SIMPLE-SIGNAGE-EDITOR
   * cancel delivery
   *
   * @param deviceIds
   */
  cancelDelivery(deviceIds: Array<Number>): Observable<Array<string>> {
    return this.http.post<Array<string>>(`${this.simpleDeliveryStatusUrl}/cancel-delivery`, deviceIds);
  }

  /**
   * Update detail status for device
   *
   * @param deviceInfo
   * @returns
   */
  public updateDetailStatusForDevice(deviceInfo: DeviceCalendar): any {
    return this.http.post(`${this.simpleDeliveryStatusUrl}/update-detail-status-for-device`, deviceInfo);
  }

  /**
   * save detail status for devices checked
   *
   * @param deviceInfos
   * @returns
   */
  public saveDetailStatusForDevices(deviceInfos: Array<DeviceCalendar>): Observable<void> {
    return this.http.post<void>(`${this.simpleDeliveryStatusUrl}/save-detail-status-for-devices`, deviceInfos);
  }
  /**
   * get device information
   *
   * @param deviceIds
   * @returns
   */
  public getDeviceInfo(deviceIds: string): Observable<any> {
    const params = new HttpParams().set('deviceIds', deviceIds);
    return this.http.get<any>(`${this.simpleDeliveryStatusUrl}/get-device-information`, { params });
  }

  /**
   * get Status Device Information Timetable Editor
   * @param checkedDevices
   * @returns
   */
  public getStatusDeviceTimetableEditor(checkedDevices: DeviceCalendar[]): Observable<any> {
    return this.http.post<any>(`${this.deliveryStatusTimetableUrl}/get-device-information-not-yet-completed`, checkedDevices);
  }
}
